export enum UserEntityStatus {
  inviteRequested = "inv_req",
  active = "active",
  requestDeclined = "req_declined",
  inactive = "inactive",
  accDeleted = "acc_deleted",
  left = "left",
}
